import { render, staticRenderFns } from "./WonderUplimitPromotionDaily.vue?vue&type=template&id=69bc609c&scoped=true"
import script from "./WonderUplimitPromotionDaily.vue?vue&type=script&lang=js"
export * from "./WonderUplimitPromotionDaily.vue?vue&type=script&lang=js"
import style0 from "./WonderUplimitPromotionDaily.vue?vue&type=style&index=0&id=69bc609c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc609c",
  null
  
)

export default component.exports